.notice {
  display: flex;
  align-items: flex-start;
  gap: 0.45em;
  margin-inline-start: auto;
  padding: 0.35em 0.55em;
  border: 0.14rem solid var(--status-critical);
  border-radius: var(--radius);
  color: var(--ink-primary);
  background: var(--surface-raised);
  font-size: 0.7em;
  line-height: 1.3;
}
.notice > span:first-child {
  color: var(--status-critical);
}
.notice a,
.blocked a {
  color: inherit;
  text-decoration-color: var(--status-critical);
}
.blocked {
  max-width: 42rem;
  margin: 12vh auto;
  padding: 2rem;
  border: 0.25rem solid var(--status-critical);
  border-radius: var(--radius);
  background: var(--surface-raised);
}
.blocked h1 {
  color: var(--status-critical);
}
@media (max-width: 64rem) {
  .notice {
    margin-inline-start: 0;
  }
}
